import { render, staticRenderFns } from "./Objective.vue?vue&type=template&id=704ba1c4&"
import script from "./Objective.vue?vue&type=script&lang=js&"
export * from "./Objective.vue?vue&type=script&lang=js&"
import style0 from "./Objective.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports